var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{on:{"page:beforein":_vm.beforein}},[_c('navbar',{attrs:{"text":`${_vm.$t('LeftPanel_title_analisys')} > ${_vm.$t('copyAnalytics')}`}}),_vm._v(" "),(_vm.loaded)?_c('AnalyticsTable',{attrs:{"data-source":_vm.customStore}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }